<!-- 递归渲染菜单 -->
<ng-container *ngFor="let item of menuItems">
  <!-- 有子菜单的项 -->
  <li
    nz-submenu
    *ngIf="item.children && item.children.length > 0 && item.is_menu && !item.is_leaf"
    [nzTitle]="titleTpl"
    nzPlacement="bottomLeft"
  >
      <ng-template #titleTpl>
         <div >

           <!-- 一级菜单图标 -->
           <span nz-icon [nzType]="item.icon || 'folder'" nzTheme="outline"></span>
           <span>{{ item.name }}</span>
         </div>
      </ng-template>
    
    <ul>
      <!-- 递归调用自身渲染子菜单 -->
      <app-menu
        [menuItems]="item.children"
        (menuItemClick)="handleMenuItemClick($event)"
      ></app-menu>
    </ul>
  </li>
  
  <!-- 无子菜单的普通项 -->
  <li
    nz-menu-item
    *ngIf="item.is_menu && item.is_leaf"
    (click)="handleMenuItemClick(item)"
  >
    <div>
      <!-- 一级菜单图标 -->
      <span nz-icon [nzType]="item.icon || 'file'" nzTheme="outline"></span>
      <span>{{ item.name }}</span>
    </div>
  </li>
</ng-container>